import { ReactComponent as CancelIcon } from 'assets/icons/close16.svg'
import { editTodoListItemContent } from 'common/Prose/Commands/todoListItem/editTodoListItemContent'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { findInlineTodoById } from 'common/Prose/utils/findInlineTodoById'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import { IconButton } from 'components/IconButton/IconButton'
import { TodoForm } from 'components/TodoForm/TodoForm'
import { TodoFormValues } from 'components/TodoForm/Types'
import { observer } from 'mobx-react-lite'
import { useContext, useEffect, useRef } from 'react'
import { useRootStore } from 'stores/RootStore'
import Styles from './TodoItemEditForm.module.scss'
import { TodoItemEditFormProps } from './Types'
import { EditorViewContext } from 'common/Prose/EditorProvider/EditorProviderContext'

const TodoItemEditForm = observer(({ todo, initialFocus = 'title' }: TodoItemEditFormProps) => {
  const rootStore = useRootStore()
  const editorViewContext = useContext(EditorViewContext)
  const view = editorViewContext ? useEditorView() : null

  const { setEditing } = useCollabItemContext()
  const { title, html_title, description, html_description, due_date, assignee } = todo
  const titleInputRef = useRef<HTMLDivElement | null>(null)
  const descriptionInputRef = useRef<HTMLDivElement | null>(null)

  const handleSubmit = async ({ assignee, ...values }: TodoFormValues) => {
    rootStore.todos.update(todo.id, { assigneeId: assignee?.id || null, ...values })

    if (view) {
      const { state, dispatch } = view
      const todoNode = findInlineTodoById(state.doc, todo.id)
      if (todoNode) {
        editTodoListItemContent(todoNode, values.title)(state, dispatch)
      }
    }
    setEditing(undefined)
  }

  const handleCancel = () => {
    setEditing(undefined)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (initialFocus === 'title') {
        titleInputRef.current?.focus()
      } else {
        descriptionInputRef.current?.focus()
      }
    }, 50)
    return () => clearTimeout(timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={Styles.wrapper}>
      <TodoForm
        className={Styles.form}
        initialValues={{
          title: title,
          htmlTitle: html_title,
          description: description,
          htmlDescription: html_description,
          dueDate: due_date || null,
          assignee: assignee || null,
        }}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        showCheckbox
        submitButtonLabel="Update"
        titleInputRef={titleInputRef}
        descriptionInputRef={descriptionInputRef}
        secondaryCta={<IconButton variant="tertiary" title="Cancel" icon={CancelIcon} isDisabled={false} />}
      />
    </div>
  )
})

export { TodoItemEditForm }
